import {
  ModelAPIRawRequestBodyType,
  ModelAPIRequestBodyType
} from '../../types/model/api-request-body';

export const ModelAPIRequestBody = ({
  name,
  companyId,
  adoptedVersionId
}: ModelAPIRequestBodyType): ModelAPIRawRequestBodyType => ({
  name,
  company_id: companyId,
  adopted_version_id: adoptedVersionId
});

export const ModelAPIRequestBodyPartial = ({
  name,
  companyId,
  adoptedVersionId
}: Partial<ModelAPIRequestBodyType>): Partial<ModelAPIRawRequestBodyType> => ({
  name,
  company_id: companyId,
  adopted_version_id: adoptedVersionId
});
